import React from "react";
import PropTypes from "prop-types";
//widgets
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
//local
import Transition from "./Transition";

function Confirm(props) {
  const randomNumber = Math.random()
    .toString(36)
    .substr(2, 5);
  const { open, onClose, title, content, button, className } = props;

  return (
    <Dialog
      open={open}
      className={className}
      TransitionComponent={Transition}
      onClose={onClose}
      aria-labelledby={randomNumber + "-title"}
      aria-describedby={randomNumber + "-description"}
    >
      <DialogTitle id={randomNumber + "-title"}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id={randomNumber + "-description"}>
          {content.text}
        </DialogContentText>
        {content.subtext ? <small>{content.subtext}</small> : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={button.click}
          disabled={button.disabled}
          color="primary"
        >
          {button.text}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

Confirm.defaultProps = {
  buttonText: "OK",
};

Confirm.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.shape({
    text: PropTypes.string.isRequired,
    subtext: PropTypes.string,
  }).isRequired,
  button: PropTypes.shape({
    text: PropTypes.string.isRequired,
    click: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
  }).isRequired,
  className: PropTypes.string,
};

export default Confirm;
